/* eslint-disable react/no-direct-mutation-state */
/* eslint-disable no-unused-vars */
import { Card, LinearProgress } from "@material-ui/core";
import axios from "axios";
import React, { Component } from "react";
import { Button, Form, Modal, Table } from "react-bootstrap";
import swal from "sweetalert";
import { NoticeManajemenRole } from "../../../../../_metronic/_partials/controls";
import AppConfig from "../../../../config/AppConfig";
import {
  MDBPagination,
  MDBPageItem,
  MDBPageNav,
  MDBCol,
  MDBRow,
} from "mdbreact";

class ManajemenRole extends Component {
  constructor(props, context) {
    super(props, context);
    this.modalAdd = this.modalAdd.bind(this);
    this.modalEdit = this.modalEdit.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }
  state = {
    // MODAL ============================
    showAddRole: false,
    showDetailsRole: false,
    showDialogDelete: false,
    // ==================================
    loadingBtn: false,
    loadingList: true,
    loadingSearch: false,
    // ==================================
    getRole: [],
    // PAGINATION & SEARCH
    keyword: "",
    totalData: 0,
    totalPaginationNumber: 0,
    limit: 10,
    start: 0,
    currentPage: 1,
    pageLimit: 5,
    showFrom: 0,
    // FORM
    id_peran: "",
    nm_peran: "",
    nm_peranEdit: "",
  };

  handleClose() {
    this.setState({
      showAddRole: false,
      showDetailsRole: false,
      showDialogDelete: false,
      loadingBtn: false,
      id_peran: "",
      nm_peran: "",
      nm_peranEdit: "",
    });
  }

  onInputForm = (e, type) => {
    this.setState({
      [type]: e.target.value,
    });
  };

  // List ============================================================================
  componentDidMount() {

    let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));

    if(sessiondata.i_idrole !== 1 && sessiondata.i_idrole !== 10) {
       window.location.href = "/"; 
    }

    this.setState({ loadingList: true });
    var formData = new FormData();
    formData.append("data[keyword]", this.state.keyword);

    let userdata = JSON.parse(localStorage.getItem("userdata"));
    let session = "";
    if (userdata) {
      session =
        "&id_pengguna=" +
        userdata.id_pengguna +
        "&id_unit=" +
        sessiondata.i_idunit +
        "&id_role=" +
        sessiondata.i_idrole;
    }

    axios
      .post(
        AppConfig.ListManajemenRole +
          "?limit=" +
          this.state.limit +
          "&start=" +
          this.state.start + session,
        formData
      )
      .then((res) => {
        this.setState(
          {
            loadingList: false,
            loadingSearch: false,
            getRole: res.data.result.data.Result,
            totalData: res.data.result.total_rows,
            totalPaginationNumber: Math.ceil(
              res.data.result.total_rows / this.state.limit
            ),
            showFrom: (this.state.currentPage - 1) * this.state.limit + 1,
          },
          () => {
            // console.log(this.state.showFrom);
          }
        );
      })
      .catch((err) => {
        console.log(err);
      });
  }

  // Add ============================================================================
  modalAdd() {
    this.setState({
      showAddRole: true,
    });
  }

  handleSave = (e) => {
    e.preventDefault();
    var formData = new FormData();
    this.setState({ loadingBtn: true });
    let userdata = JSON.parse(localStorage.getItem("userdata"));
    let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
    let session = "";
    if (userdata) {
      session =
        // "?token="+userdata.token+`
        "?id_pengguna=" +
        userdata.id_pengguna +
        "&id_unit=" +
        sessiondata.i_idunit +
        "&id_role=" +
        sessiondata.i_idrole;
    }
    formData.append("data[nm_peran]", this.state.nm_peran);
    axios
      .post(AppConfig.SaveManajemenRole, formData)
      .then((res) => {
        this.setState({
          loadingBtn: false,
        });
        swal({
          title: "Sukses!",
          text: "Data berhasil disimpan!",
          icon: "success",
          button: "OK!",
        });
        this.componentDidMount();
        this.handleClose();
      })
      .catch((err) => {
        swal({
          title: "Gagal!",
          text: "Gagal menyimpan data!",
          icon: "error",
          button: "OK!",
        });
        console.log(err);
      });
  };

  // Edit ============================================================================
  modalEdit(val) {
    this.setState({
      showDetailsRole: true,
      id_peran: val.id_peran,
      nm_peranEdit: val.nm_peran,
    });
  }

  handleEdit = (e) => {
    e.preventDefault();
    var formData = new FormData();
    this.setState({ loadingBtn: true });
    let userdata = JSON.parse(localStorage.getItem("userdata"));
    let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
    let session = "";
    if (userdata) {
      session =
        // "?token="+userdata.token+`
        "?id_pengguna=" +
        userdata.id_pengguna +
        "&id_unit=" +
        sessiondata.i_idunit +
        "&id_role=" +
        sessiondata.i_idrole;
    }
    formData.append("data[id_peran]", this.state.id_peran);
    formData.append("data[nm_peran]", this.state.nm_peranEdit);
    axios
      .put(AppConfig.UpdateManajemenRole, formData)
      .then((res) => {
        this.setState({
          loadingBtn: false,
        });
        swal({
          title: "Sukses!",
          text: "Data berhasil diubah!",
          icon: "success",
          button: "OK!",
        });
        this.componentDidMount();
        this.handleClose();
      })
      .catch((err) => {
        swal({
          title: "Gagal!",
          text: "Gagal mengubah data!",
          icon: "error",
          button: "OK!",
        });
        console.log(err);
      });
  };

  // Delete ============================================================================
  showDialogDelete(id) {
    let userdata = JSON.parse(localStorage.getItem("userdata"));
    let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
    let session = "";
    if (userdata) {
      session =
        // "?token="+userdata.token+
        "?id_pengguna=" +
        userdata.id_pengguna +
        "&id_unit=" +
        sessiondata.i_idunit +
        "&id_role=" +
        sessiondata.i_idrole;
    }
    swal({
      title: "Apakah anda yakin?",
      text: "Data akan terhapus dan tidak tercatat pada historical",
      icon: "warning",
      buttons: true,
      dangerMode: false,
    }).then((willDelete) => {
      if (willDelete) {
        this.setState({ loadingBtn: true });
        axios
          .delete(AppConfig.DeleteManajemenRole + id + session)
          .then((res) => {
            swal({
              title: "Sukses!",
              text: "Data berhasil dihapus!",
              icon: "success",
              button: "OK!",
            });
            this.componentDidMount();
            this.setState({
              loadingBtn: false,
            });
          })
          .catch((err) => {
            swal({
              title: "Gagal!",
              text: "Gagal menghapus data!",
              icon: "error",
              button: "OK!",
            });
            this.setState({
              loadingBtn: false,
            });
          });
      }
    });
  }

  // Searh
  onClickSearch = (e) => {
    this.setState(
      {
        loadingSearch: true,
        loadingList: true,
        currentPage: 1,
      },
      () => {
        this.componentDidMount();
      }
    );
  };
  onClickResetKeyword = (e) => {
    this.setState(
      {
        keyword: "",
        loadingList: true,
        currentPage: 1,
      },
      () => {
        this.componentDidMount();
      }
    );
  };
  onInputKeyword = (e) => {
    this.setState({
      keyword: e.target.value,
    });
  };

  // Pagination
  getPaginationGroup = () => {
    let start =
      Math.floor((this.state.currentPage - 1) / this.state.pageLimit) *
      this.state.pageLimit;
    return new Array(this.state.pageLimit)
      .fill()
      .map((_, idx) => start + idx + 1);
  };

  pagination(e, item) {
    let dataStart = item * this.state.limit - this.state.limit;
    this.setState(
      {
        start: dataStart,
        currentPage: item,
      },
      () => {
        this.componentDidMount();
      }
    );
  }
  firstPagination = () => {
    let first = this.state.currentPage / this.state.currentPage;
    let dataStart = first * this.state.limit - this.state.limit;
    this.setState(
      {
        start: dataStart,
        currentPage: first,
      },
      () => {
        this.componentDidMount();
      }
    );
  };
  prevPagination = () => {
    let prev = this.state.currentPage - 1;
    let dataStart = prev * this.state.limit - this.state.limit;
    this.setState(
      {
        start: dataStart,
        currentPage: prev,
      },
      () => {
        this.componentDidMount();
      }
    );
  };
  nextPagination = () => {
    let next = this.state.currentPage + 1;
    let dataStart = next * this.state.limit - this.state.limit;
    this.setState(
      {
        start: dataStart,
        currentPage: next,
      },
      () => {
        this.componentDidMount();
      }
    );
  };
  lastPagination = () => {
    let last = this.state.totalPaginationNumber;
    let dataStart = last * this.state.limit - this.state.limit;
    this.setState(
      {
        start: dataStart,
        currentPage: last,
      },
      () => {
        this.componentDidMount();
      }
    );
  };

  // Layout ============================================================================
  render() {
    let userdata = JSON.parse(localStorage.getItem("sessiondata"));

    let i = 0;
    let list_result = [];
    if (this.state.getRole !== undefined) {
      for (var key in this.state.getRole) {
        list_result[i] = {
          result: this.state.getRole[key],
        };
        i++;
      }
    }
    let no = this.state.showFrom - 1;

    let resetKeyword = <></>;
    if (this.state.keyword !== "") {
      resetKeyword = (
        <i
          onClick={(e) => this.onClickResetKeyword(e)}
          className="flaticon-close text-dark"
          style={{
            position: "absolute",
            zIndex: 2,
            right: "25px",
            bottom: "10px",
            cursor: "pointer",
          }}
        ></i>
      );
    }

    let loadingSearch = <></>;
    if (this.state.loadingSearch === true) {
      loadingSearch = (
        <i
          className="spinner spinner-white"
          style={{ marginRight: "20px" }}
        ></i>
      );
    }

    let searchComponent = <></>;
    searchComponent = (
      <>
        <div className="row">
          <div className="col-md-6">
            <i
              className="flaticon-search text-dark"
              style={{
                position: "absolute",
                zIndex: 2,
                left: "25px",
                bottom: "10px",
              }}
            ></i>
            {resetKeyword}
            <input
              type="text"
              style={{ paddingLeft: "40px" }}
              className={`form-control form-control-lg form-control-solid `}
              placeholder="Masukan keyword : Nama role.."
              onChange={(e) => this.onInputKeyword(e)}
              autoComplete="off"
              name="keyword"
              value={this.state.keyword}
            />
          </div>
          <div className="col-md-2 text-left">
            <Button
              onClick={(e) => this.onClickSearch(e)}
              variant="secondary"
              style={{ padding: "12px", width: "100%" }}
            >
              {loadingSearch} Cari
            </Button>
          </div>
          <div className="col-md-4 text-right">
            <Button
              onClick={this.modalAdd}
              variant="primary"
              style={{
                padding: "12px",
                width: "50%",
              }}
            >
              <i
                className="flaticon-add"
                style={{ color: "#ffffff", fontSize: "14px" }}
              ></i>
              &nbsp; Tambah Role
            </Button>
          </div>
        </div>
      </>
    );

    let pagination = <></>;
    if (this.state.loadingList === false) {
      pagination = (
        <>
          <div className="col-md-8" style={{ textAlign: "center" }}>
            <MDBRow>
              <MDBCol>
                <MDBPagination circle>
                  <MDBPageItem
                    className={`prev ${
                      this.state.currentPage === 1 ? "disabled" : ""
                    }`}
                  >
                    <MDBPageNav
                      className="page-link"
                      onClick={(e) => this.firstPagination(e)}
                    >
                      <span>First</span>
                    </MDBPageNav>
                  </MDBPageItem>
                  <MDBPageItem
                    className={`prev ${
                      this.state.currentPage === 1 ? "disabled" : ""
                    }`}
                  >
                    <MDBPageNav
                      className="page-link"
                      aria-label="Previous"
                      onClick={(e) => this.prevPagination(e)}
                    >
                      <span aria-hidden="true">&laquo;</span>
                      <span className="sr-only">Previous</span>
                    </MDBPageNav>
                  </MDBPageItem>
                  {this.getPaginationGroup()
                    .filter(
                      (index) => index <= this.state.totalPaginationNumber
                    )
                    .map((item, index) => (
                      <MDBPageItem
                        active={this.state.currentPage === item ? true : false}
                        key={index}
                      >
                        <MDBPageNav
                          className="page-link"
                          onClick={(e) => this.pagination(e, item)}
                        >
                          {item}
                        </MDBPageNav>
                      </MDBPageItem>
                    ))}
                  <MDBPageItem
                    disabled={
                      this.state.currentPage ===
                      this.state.totalPaginationNumber
                        ? true
                        : false
                    }
                  >
                    <MDBPageNav
                      className="page-link"
                      onClick={(e) => this.nextPagination(e)}
                    >
                      &raquo;
                    </MDBPageNav>
                  </MDBPageItem>
                  <MDBPageItem
                    disabled={
                      this.state.currentPage ===
                      this.state.totalPaginationNumber
                        ? true
                        : false
                    }
                  >
                    <MDBPageNav
                      className="page-link"
                      onClick={(e) => this.lastPagination(e)}
                    >
                      Last
                    </MDBPageNav>
                  </MDBPageItem>
                </MDBPagination>
              </MDBCol>
            </MDBRow>
          </div>
        </>
      );
    }

    return (
      <>
        <NoticeManajemenRole style={{ marginBottom: "0px", boxShadow: "none" }}>
          <strong style={{ fontSize: "18px" }}>Manajemen Role</strong>
          <p>Pengaturan Role SPMI</p>
        </NoticeManajemenRole>
        <br />
        <Card style={{ padding: "2%" }}>
          {userdata.i_idrole === 1 || userdata.i_idrole === 10 ? (
            <div className="row" style={{ marginBottom: "20px" }}>
              <div className="col-md-12">{searchComponent}</div>
            </div>
          ) : (
            ""
          )}
          {/*========================================== Begin Table ========================================== */}
          <Table responsive hover style={{ overflow: "auto" }}>
            <thead
              className="text-white"
              style={{ backgroundColor: "#3047ad" }}
            >
              <tr>
                <th
                  style={{
                    width: "5%",
                    fontSize: "12px",
                    textTransform: "uppercase",
                    verticalAlign: "middle",
                    textAlign: "center",
                  }}
                >
                  No
                </th>
                <th
                  style={{
                    width: "80%",
                    fontSize: "12px",
                    textTransform: "uppercase",
                    verticalAlign: "middle",
                  }}
                >
                  Nama Role
                </th>
                <th
                  className="text-center"
                  style={{
                    width: "15%",
                    fontSize: "12px",
                    textTransform: "uppercase",
                    verticalAlign: "middle",
                    textAlign: "center",
                  }}
                >
                  Aksi
                </th>
              </tr>
            </thead>
            <tbody>
              {this.state.loadingList === true ? (
                <tr>
                  <td colSpan="3">
                    <LinearProgress color="secondary" variant="query" />
                  </td>
                </tr>
              ) : list_result.length > 0 ? (
                list_result.map((list) => (
                  <tr key={list.result.id_peran}>
                    <td
                      style={{ verticalAlign: "middle", textAlign: "center" }}
                    >
                      {(no = no + 1)}
                    </td>
                    <td style={{ verticalAlign: "middle" }}>
                      {list.result.nm_peran}
                    </td>
                    <td
                      style={{ verticalAlign: "middle", textAlign: "center" }}
                    >
                      <Button
                        onClick={() => this.modalEdit(list.result)}
                        className="btn btn-icon btn-success btn-sm"
                        style={{
                          minWidth: "50px",
                          marginRight: "10px",
                          borderRadius: "12px",
                        }}
                      >
                        <i
                          className="flaticon-edit"
                          style={{ color: "#FFFFFF", fontSize: "14px" }}
                        ></i>
                      </Button>
                      <Button
                        onClick={() =>
                          this.showDialogDelete(list.result.id_peran)
                        }
                        className="btn btn-icon btn-danger btn-sm"
                        style={{
                          minWidth: "50px",
                          marginLeft: "10px",
                          borderRadius: "12px",
                        }}
                      >
                        <i
                          className="flaticon-delete"
                          style={{ color: "#FFFFFF", fontSize: "14px" }}
                        ></i>
                      </Button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="3" style={{ textAlign: "center" }}>
                    <em>Data does not exist</em>
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
          <div className="row" style={{ marginTop: "10px" }}>
            <div className="col-md-4 text-left">
              {" "}
              <label style={{ fontSize: 11, fontStyle: "italic" }}>
                Page <strong>{this.state.currentPage}</strong> of{" "}
                <strong>{this.state.totalPaginationNumber}</strong>
              </label>
            </div>
            <div className="col-md-4 text-center">{pagination}</div>
            <div className="col-md-4 text-right">
              <label style={{ fontSize: 11, fontStyle: "italic" }}>
                Showing <strong>{this.state.showFrom}</strong> to{" "}
                <strong>
                  {this.state.showFrom + this.state.getRole.length - 1}
                </strong>{" "}
                of <strong>{this.state.totalData}</strong> Data
              </label>
            </div>
          </div>
          {/* ========================================== End Table ========================================== */}
        </Card>

        {/*========================================== Begin Modal Add ========================================== */}
        <Modal
          size="lg"
          show={this.state.showAddRole}
          onHide={this.handleClose}
        >
          <Modal.Header>
            <Modal.Title>Form Penambahan Role</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Label>Nama Role</Form.Label>
            <Form.Control
              size="lg"
              type="text"
              placeholder="Masukkan nama role..."
              value={this.state.nm_peran}
              onChange={(e) => this.onInputForm(e, "nm_peran")}
            />
          </Modal.Body>
          <Modal.Footer>
            <div style={{ textAlign: "right" }}>
              <Button
                onClick={this.handleSave}
                disabled={this.state.loadingBtn}
                style={{
                  marginRight: "1vw",
                  backgroundColor: "#2061e3",
                  color: "white",
                }}
                variant="primary"
              >
                SIMPAN
                {this.state.loadingBtn && (
                  <i className="ml-3 spinner spinner-white"></i>
                )}
                &nbsp;&nbsp;
              </Button>
            </div>
            <Button
              variant="secondary"
              disabled={this.state.loadingBtn}
              onClick={this.handleClose}
            >
              Tutup
            </Button>
          </Modal.Footer>
        </Modal>
        {/*========================================== End Modal Add ========================================== */}

        {/*========================================== Begin Modal Edit ========================================== */}
        <Modal
          size="lg"
          show={this.state.showDetailsRole}
          onHide={this.handleClose}
        >
          <Modal.Header closeButton>
            <Modal.Title>Form Edit Role</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Label>Nama Role</Form.Label>
            <Form.Control
              size="lg"
              type="text"
              value={this.state.nm_peranEdit}
              onChange={(e) => this.onInputForm(e, "nm_peranEdit")}
            />
          </Modal.Body>
          <Modal.Footer>
            <div style={{ textAlign: "right" }}>
              <Button
                onClick={this.handleEdit}
                disabled={this.state.loadingBtn}
                style={{
                  marginRight: "1vw",
                  backgroundColor: "#2061e3",
                  color: "white",
                }}
                variant="primary"
              >
                SIMPAN
                {this.state.loadingBtn && (
                  <i className="ml-3 spinner spinner-white"></i>
                )}
                &nbsp;&nbsp;
              </Button>
            </div>
            <Button
              variant="secondary"
              disabled={this.state.loadingBtn}
              onClick={this.handleClose}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
        {/*========================================== End Modal Edit ========================================== */}
      </>
    );
  }
}
export default ManajemenRole;
